import { createElement, Component } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var GoogleTagManager = (function (_super) {
    __extends(GoogleTagManager, _super);
    function GoogleTagManager(props) {
        var _this = _super.call(this, props) || this;
        window.dataLayer = window.dataLayer || [];
        return _this;
    }
    GoogleTagManager.prototype.componentDidMount = function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? "&l=" + l : '';
            j.async = true;
            j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', this.props.gtmId);
        if (!this.props.gtmTrackingConfig && GoogleTagManager.checkForIframe()) {
            window.dataLayer.push({
                event: 'iframeload',
                pagetype: 'embedded content',
                category: 'interactive'
            });
            return;
        }
        if (this.props.gtmTrackingConfig) {
            var datalayerInformation = __assign(__assign({}, this.props.gtmTrackingConfig), { article_type: 'interactive-standalone', premium: this.props.gtmTrackingConfig.premium ? 1 : 0 });
            window.dataLayer.push(__assign(__assign({ event: 'pageview' }, datalayerInformation), { uid: undefined }));
        }
    };
    GoogleTagManager.prototype.render = function () {
        return (createElement("noscript", null,
            createElement("iframe", { src: "//www.googletagmanager.com/ns.html?id=" + this.props.gtmId, height: '0', width: '0', style: {
                    display: 'none',
                    visibility: 'hidden',
                    position: 'absolute'
                } })));
    };
    GoogleTagManager.checkForIframe = function () {
        try {
            return window.self !== window.top;
        }
        catch (e) {
            return true;
        }
    };
    return GoogleTagManager;
}(Component));

export default GoogleTagManager;
export { GoogleTagManager };
//# sourceMappingURL=index.js.map
